import TopNav from "./TopNav";

const AppHeader = () => {

    return (

            <div className="App-header">
                <h2>
                    <a href="/">Delfin Technologies Inc.</a>
                    <a className="mentor-badge" target="_blank" href="https://www.codementor.io/@jafideler?refer=badge">
                        <img src="https://www.codementor.io/m-badges/jafideler/contact-me.svg" alt="Codementor badge" />
                    </a>
                    <a href="/" className="pull-right">
                        <img alt="Delfin Logo" src="../assets/img/Delfin Logo.png" />
                    </a>
                </h2>

                <TopNav />
            </div>

    )
}
export default AppHeader;  